import jwtDecode from 'jwt-decode';
import { AnyAction, Dispatch } from 'redux';
import { AUTH_START, AUTH_SUCCESS, AUTH_FAIL, AUTH_REFRESH_SUCCESS, AUTH_REFRESH_FAIL } from './actionTypes';

export const authStart = () => (dispatch: Dispatch<AnyAction>) => {
  dispatch({ 
    type: AUTH_START 
  });
}

export const authSuccess = (accessToken: string) => (dispatch: Dispatch<AnyAction>) => {
  const decodedToken: any = jwtDecode(accessToken);

  return dispatch({ 
    type: AUTH_SUCCESS,
    uuid: decodedToken?.oid, 
    name: decodedToken?.name,
    roles: decodedToken?.roles,

    // record the access token in the reducer for local debugging
    accessToken: process.env.AZURE_ENV !== "production" && accessToken 
  });
}

export const authFail = (authError: Error) => (dispatch: Dispatch<AnyAction>) => {
  return dispatch({ 
    type: AUTH_FAIL, 
    error: authError 
  });
}

export const authRefreshSuccess = (accessToken: string) => (dispatch: Dispatch<AnyAction>) => {
  const decodedToken: any = jwtDecode(accessToken);

  return dispatch({ 
    type: AUTH_REFRESH_SUCCESS,
    uuid: decodedToken?.oid, 
    name: decodedToken?.name,
    roles: decodedToken?.roles,

    // record the access token in the reducer for local debugging
    accessToken: process.env.AZURE_ENV !== "production" && accessToken 
  });
}

export const authRefreshFail = (authError: Error) => (dispatch: Dispatch<AnyAction>) => {
  return dispatch({ 
    type: AUTH_REFRESH_FAIL, 
    error: authError 
  });
}